var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Emit, Inject, Prop, Vue, } from "vue-property-decorator";
import ArticleNameElement from "../../components/articleattributes/articlenameelement.vue";
import MaterialElement from "../../components/articleattributes/materialelement.vue";
import MultiplicityElement from "../../components/articleattributes/multiplicityelement.vue";
import ThicknessElement from "../../components/articleattributes/thicknesselement.vue";
import { clone, createPngImage, objEq, } from "../utilities/aux";
import { editStep, isArticleWithContent, } from "../utilities/wizard";
import { isArray, } from "../utilities/wsi4_typeguards";
let WizardContent = class WizardContent extends Vue {
    constructor() {
        super(...arguments);
        this.newContents = [];
        this.svgElements = [];
    }
    contentChanged() {
        return this.newContents;
    }
    changeName(index, n) {
        this.newContents[index].content.articleName = n;
        this.contentChanged();
    }
    changeThickness(index, t) {
        this.newContents[index].content.thickness = t;
        this.contentChanged();
    }
    changeMaterial(index, m) {
        this.newContents[index].content.materialWithGas = m;
        this.contentChanged();
    }
    changeMultiplicity(index, m) {
        this.newContents[index].content.multiplicity = m;
        this.contentChanged();
    }
    pictureCssClass(index) {
        return "wizard-content-article-picture-" + index.toString();
    }
    showPng(index) {
        return this.articles[index].png !== undefined;
    }
    showSvg(index) {
        return this.articles[index].svg !== undefined;
    }
    png(index) { return this.showPng(index) ? createPngImage(this.articles[index].png) : undefined; }
    cloneArticles() {
        return clone((this.articles), (arg) => isArray(arg, isArticleWithContent));
    }
    updateContent() {
        for (const s of this.svgElements) {
            while (s.firstChild) {
                s.removeChild(s.firstChild);
            }
        }
        this.newContents = this.cloneArticles();
        for (let index = 0; index < this.newContents.length; ++index) {
            const svg = this.showSvg(index);
            if (!this.showPng(index) && !svg) {
                throw Error(`At least one picture for ${index} has to exist`);
            }
            if (svg) {
                const css = this.pictureCssClass(index);
                {
                    const s = this.$el.querySelector("." + css);
                    if (s === undefined || s === null) {
                        throw Error(`Selector ${css} does not match`);
                    }
                    s.appendChild((new DOMParser())
                        .parseFromString(this.articles[index].svg, "image/svg+xml").documentElement);
                    this.svgElements.push(s);
                }
            }
        }
    }
    changePartInStep(articleContent) {
        const a = this.projectEntries.find(a => a.vertexKey === articleContent.articleVertexKey);
        if (a === undefined) {
            throw Error("Missing article");
        }
        return editStep(this.step, a);
    }
    created() {
        this.newContents = this.cloneArticles();
    }
    updated() {
        if (!objEq(this.articles, this.newContents)) {
            this.updateContent();
        }
    }
    mounted() {
        this.updateContent();
    }
};
__decorate([
    Prop({ required: true })
], WizardContent.prototype, "articles", void 0);
__decorate([
    Prop({ required: true })
], WizardContent.prototype, "projectEntries", void 0);
__decorate([
    Prop({ required: true })
], WizardContent.prototype, "shopConfig", void 0);
__decorate([
    Prop({ required: true })
], WizardContent.prototype, "step", void 0);
__decorate([
    Inject()
], WizardContent.prototype, "i18n", void 0);
__decorate([
    Emit()
], WizardContent.prototype, "contentChanged", null);
WizardContent = __decorate([
    Component({
        components: {
            ArticleNameElement,
            ThicknessElement,
            MaterialElement,
            MultiplicityElement,
        },
        name: "WizardContent",
    })
], WizardContent);
export default WizardContent;
